__turbopack_context__.v({
  "actionButton": "ChatHistory-module-scss-module__v6DnWW__actionButton",
  "centered": "ChatHistory-module-scss-module__v6DnWW__centered",
  "input": "ChatHistory-module-scss-module__v6DnWW__input",
  "inputWrapper": "ChatHistory-module-scss-module__v6DnWW__inputWrapper",
  "label": "ChatHistory-module-scss-module__v6DnWW__label",
  "leftIcon": "ChatHistory-module-scss-module__v6DnWW__leftIcon",
  "query": "ChatHistory-module-scss-module__v6DnWW__query",
  "root": "ChatHistory-module-scss-module__v6DnWW__root",
});
